'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _TableCell = require('./TableCell');

var _TableCell2 = _interopRequireDefault(_TableCell);

var _ExpandIcon = require('./ExpandIcon');

var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var TableRow = (0, _createReactClass2.default)({
  propTypes: {
    onDestroy: _propTypes2.default.func,
    onRowClick: _propTypes2.default.func,
    record: _propTypes2.default.object,
    prefixCls: _propTypes2.default.string,
    expandIconColumnIndex: _propTypes2.default.number,
    onHover: _propTypes2.default.func,
    columns: _propTypes2.default.array,
    style: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    index: _propTypes2.default.number,
    hoverKey: _propTypes2.default.any,
    expanded: _propTypes2.default.bool,
    expandable: _propTypes2.default.any,
    onExpand: _propTypes2.default.func,
    needIndentSpaced: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    indent: _propTypes2.default.number,
    indentSize: _propTypes2.default.number,
    expandIconAsCell: _propTypes2.default.bool,
    expandRowByClick: _propTypes2.default.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onRowClick: function onRowClick() {},
      onDestroy: function onDestroy() {},

      expandIconColumnIndex: 0,
      expandRowByClick: false,
      onHover: function onHover() {}
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return !(0, _shallowequal2.default)(nextProps, this.props);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props.onDestroy(this.props.record);
  },
  onRowClick: function onRowClick(event) {
    var _props = this.props;
    var record = _props.record;
    var index = _props.index;
    var onRowClick = _props.onRowClick;
    var expandable = _props.expandable;
    var expandRowByClick = _props.expandRowByClick;
    var expanded = _props.expanded;
    var onExpand = _props.onExpand;


    if (expandable && expandRowByClick) {
      onExpand(!expanded, record);
    }
    onRowClick(record, index, event);
  },
  onMouseEnter: function onMouseEnter() {
    var _props2 = this.props;
    var onHover = _props2.onHover;
    var hoverKey = _props2.hoverKey;

    onHover(true, hoverKey);
  },
  onMouseLeave: function onMouseLeave() {
    var _props3 = this.props;
    var onHover = _props3.onHover;
    var hoverKey = _props3.hoverKey;

    onHover(false, hoverKey);
  },
  render: function render() {
    var _props4 = this.props;
    var prefixCls = _props4.prefixCls;
    var columns = _props4.columns;
    var record = _props4.record;
    var style = _props4.style;
    var visible = _props4.visible;
    var index = _props4.index;
    var hoverKey = _props4.hoverKey;
    var expandIconColumnIndex = _props4.expandIconColumnIndex;
    var expandIconAsCell = _props4.expandIconAsCell;
    var expanded = _props4.expanded;
    var expandRowByClick = _props4.expandRowByClick;
    var expandable = _props4.expandable;
    var onExpand = _props4.onExpand;
    var needIndentSpaced = _props4.needIndentSpaced;
    var className = _props4.className;
    var indent = _props4.indent;
    var indentSize = _props4.indentSize;
    var rowSelection = _props4.rowSelection;


    var cells = [];

    for (var i = 0; i < columns.length; i++) {
      if (expandIconAsCell && i === 0) {
        /*** add by jiazhao 2017-02-09 添加rowSelection的render方法  ***/
        var expandIcon = _react2.default.createElement(_ExpandIcon2.default, {
          expandable: expandable,
          prefixCls: prefixCls,
          onExpand: onExpand,
          needIndentSpaced: needIndentSpaced,
          expanded: expanded,
          record: record
        }),
            colSpan = void 0,
            rowSpan = void 0,
            tdProps = void 0;
        if (this.props.rowSelection && this.props.rowSelection.render) {
          var expandRender = this.props.rowSelection.render;
          expandIcon = expandRender(record, index, expandIcon);
          if (expandIcon && !_react2.default.isValidElement(expandIcon) && Object.prototype.toString.call(expandIcon) === '[object Object]') {
            tdProps = expandIcon.props || {};
            rowSpan = tdProps.rowSpan;
            colSpan = tdProps.colSpan;
            expandIcon = expandIcon.children;
          }
        }
        if (rowSpan === 0 || colSpan === 0) {
          cells.push(_react2.default.createElement('td', { style: { display: "none" } }));
        }
        cells.push(_react2.default.createElement(
          'td',
          { className: prefixCls + '-expand-icon-cell',
            key: 'rc-table-expand-icon-cell' },
          expandIcon
        ));
        /*** add end ***/
      }
      var isColumnHaveExpandIcon = expandIconAsCell || expandRowByClick ? false : i === expandIconColumnIndex;
      cells.push(_react2.default.createElement(_TableCell2.default, {
        prefixCls: prefixCls,
        record: record,
        indentSize: indentSize,
        indent: indent,
        index: index,
        expandable: expandable,
        onExpand: onExpand,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        isColumnHaveExpandIcon: isColumnHaveExpandIcon,
        column: columns[i],
        key: hoverKey + "_" + columns[i].key,
        rowSelection: rowSelection
      }));
    }

    return _react2.default.createElement(
      'tr',
      {
        onClick: this.onRowClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent,
        style: visible ? style : _extends({}, style, { display: 'none' })
      },
      cells
    );
  }
});

exports.default = TableRow;